import React, { ReactElement } from 'react';

const SvgIcon = (Icon: any): any => {
  return (): ReactElement => {
    return (
      <>
        <Icon />
      </>
    );
  };
};

export default SvgIcon;
